export enum QfaEventType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  DEBUG = 'DEBUG',
}
